import React, { useContext, useState, useEffect, useMemo } from 'react';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Slide,
  Snackbar,
  Toolbar,
  Typography,
} from '@mui/material';

//Custom Components
import Navigation from '../../Components/Navigation/navigation';
import DataContext from '../../Contexts/DataContext';
import { useAuth } from '../../Contexts/AuthContext';
import ProjectSelector from '../../Components/ProjectSelector/projectSelector';
import { Copyright } from '../../Helpers/utils';

function ProjectSelect(props){
  const auth = useAuth();
  const activeUser = auth.activeUser;
  const context = useContext(DataContext);

  return(
    <Box 
      sx={{ 
        display: 'flex' 
      }}
    >
      <Navigation title={'Project Home'} />
      <Box
        component='main'
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          minHeight: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container item xs={12}>
            <Container 
              maxWidth='lg'
              sx={{
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                height: '100%',
                mb: 4,
                mt: 4,
              }}
            >
              <ProjectSelector 
                isLoading={false}
              />
            </Container>
          </Grid>
        </Box>
        <Box component="footer">
          <Container maxWidth="lg">
            <Copyright sx={{ py: 3 }} />
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

export default ProjectSelect;